import { render, staticRenderFns } from "./life-bank-milestone-message.vue?vue&type=template&id=61f6c341&"
import script from "./life-bank-milestone-message.vue?vue&type=script&lang=js&"
export * from "./life-bank-milestone-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports